import { EmailsActive } from '@Containers/Emails';

const ScriptsActivePage: React.FunctionComponent = (): JSX.Element => (
  <EmailsActive />
);

export default ScriptsActivePage;
